import { useQuery } from '@apollo/client';

import { getAbTest } from './queries/__generated__/getAbTest';
import getAbTestQuery from './queries/getAbTest.graphql';

export const useAbTest = (): string | null => {
  const { data } = useQuery<getAbTest>(getAbTestQuery, {
    fetchPolicy: 'cache-only',
  });
  return data?.RequestHeaders?.abTest || null;
};
